import { render, staticRenderFns } from "./ZCBuilding.vue?vue&type=template&id=f97c4b94&scoped=true&"
import script from "./ZCBuilding.vue?vue&type=script&lang=ts&"
export * from "./ZCBuilding.vue?vue&type=script&lang=ts&"
import style0 from "./ZCBuilding.vue?vue&type=style&index=0&id=f97c4b94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97c4b94",
  null
  
)

export default component.exports